
function Hero() {
  const goToAbout = () => {
    const el = document.getElementById('about-title');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const onKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      goToAbout();
    }
  };

  return (
    <section id="hero" className="flex flex-col items-center justify-center min-h-[calc(100vh-3.5rem)] md:min-h-screen px-4 text-center" aria-labelledby="hero-title">
      <h1 id="hero-title" className="text-3xl sm:text-4xl md:text-6xl font-pressstart neon-text mb-4 flicker">
        Ahmed Elbarbary
      </h1>
      <p className="text-base sm:text-xl md:text-2xl mb-4"> Junior Front-End Developer</p>
      <p className="text-sm sm:text-lg max-w-md mb-8">
        building modern, accessible React apps.
      </p>
      <div>
        <button
          onClick={goToAbout}
          onKeyDown={onKey}
          className="px-6 py-3 border-2 border-neon neon-glow hover:bg-neon hover:text-black transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-neon"
          aria-label="Press Start to explore"
        >
          PRESS START
        </button>
      </div>
    </section>
  );
}

export default Hero;